import { streakService } from "./streakService";

export interface WritingCorrectionRecord {
  id: string;
  correctionId?: string;
  source: "openai" | "mock_fallback" | "frontend_fallback" | "local_mock" | string;
  competency: "writing";
  competencyLabel: "Expression Écrite (EE)";
  section: string;
  instruction: string;
  originalText: string;
  correctedText?: string;
  improvedVersion: string;
  estimatedScore: number;
  maxScore: number;
  nclcEstimate: string;
  cecrlEstimate: string;
  wordCount: number;
  targetNclc: string;
  overallComment: string;
  strengths: string[];
  weaknesses: string[];
  criteria: {
    taskAchievement: {
      label: string;
      score: number;
      maxScore: number;
      comment: string;
    };
    coherence: {
      label: string;
      score: number;
      maxScore: number;
      comment: string;
    };
    grammar: {
      label: string;
      score: number;
      maxScore: number;
      comment: string;
    };
    vocabulary: {
      label: string;
      score: number;
      maxScore: number;
      comment: string;
    };
  };
  errors: Array<{
    id: string;
    category: string;
    original: string;
    corrected: string;
    explanation: string;
    severity: "low" | "medium" | "high";
  }>;
  studySuggestions: string[];
  disclaimer: string;
  createdAt: string;
  savedAt: string;
}

const STORAGE_KEY = "tef_writing_corrections";

export const writingCorrectionHistoryService = {
  // Broadcaster
  emitWritingCorrectionsUpdated() {
    window.dispatchEvent(new Event("historyUpdated"));
    window.dispatchEvent(new Event("dashboardUpdated"));
  },

  getWritingCorrections(): WritingCorrectionRecord[] {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return [];
    try {
      return JSON.parse(raw);
    } catch {
      return [];
    }
  },

  getWritingCorrectionById(id: string): WritingCorrectionRecord | null {
    const list = this.getWritingCorrections();
    return list.find(item => item.id === id) || null;
  },

  saveWritingCorrection(record: Omit<WritingCorrectionRecord, "savedAt">): WritingCorrectionRecord {
    streakService.registerActivity();
    const list = this.getWritingCorrections();
    const newRecord: WritingCorrectionRecord = {
      ...record,
      savedAt: new Date().toISOString()
    };
    list.unshift(newRecord);
    localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
    this.emitWritingCorrectionsUpdated();
    return newRecord;
  },

  deleteWritingCorrection(id: string): void {
    const list = this.getWritingCorrections();
    const filtered = list.filter(item => item.id !== id);
    localStorage.setItem(STORAGE_KEY, JSON.stringify(filtered));
    this.emitWritingCorrectionsUpdated();
  },

  clearWritingCorrections(): void {
    localStorage.setItem(STORAGE_KEY, JSON.stringify([]));
    this.emitWritingCorrectionsUpdated();
  }
};
